import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import SidebarMenu, { type SidebarMenuItem } from 'features/sidebar-menu/SidebarMenu';
import TransportOrderDetail from 'features/transport-order-detail/TransportOrderDetail';
import { selectTransportOrderDetail } from 'features/transport-order-detail/transportOrderDetailSlice';
import UserMenu from 'features/user-menu/UserMenu';
import { Outlet } from 'react-router';
import { routes } from 'routes/routes';
import { useAppSelector } from 'store/hooks';

import AppHeader from './AppHeader';

const navItems: SidebarMenuItem[] = [
    { to: `/${routes.TRANSPORT_ORDERS}`, iconName: 'finish', label: 'Transport orders' },
    { to: `/${routes.IN_TRANSIT}`, iconName: 'route-view', label: 'In transit' },
    { to: `/${routes.DELIVERED}`, iconName: 'calendar', label: 'Delivered' },
    ...(import.meta.env.DEV ? [{ to: `/${routes.ARCHIVED}`, iconName: 'archive', label: 'Archived' }] : []),
];

const actionBarItems = [<UserMenu key='userMenu' />];

const AppLayout = () => {
    const transportOrderId = useAppSelector(selectTransportOrderDetail);

    return (
        <ApplicationLayout className='bg-lighter'>
            <ApplicationLayout.Header>
                <AppHeader actionBarItems={actionBarItems} />
            </ApplicationLayout.Header>
            <ApplicationLayout.Sidebar>
                <SidebarMenu items={navItems} />
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Sidebar className='right'>
                <TransportOrderDetail id={transportOrderId} />
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Body>
                <main className='container-fluid clearance'>
                    <Outlet />
                </main>
            </ApplicationLayout.Body>
        </ApplicationLayout>
    );
};

export default AppLayout;
